

































import {
  Component, Prop, Vue,
} from 'vue-property-decorator';

@Component
export default class TransactionSigner extends Vue {
  @Prop()
  onChange!: Function;

  @Prop()
  signerKey = '';

  @Prop()
  signerAddress = '';
}

